/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
const preStyle = {
    position: 'relative',
    display: 'block',
    backgroundColor: '#000',
    padding: '0.5em',
    marginTop: '0.5em',
    marginBottom: '0.5em',
    overflowX: 'auto',
    whiteSpace: 'pre-wrap',
    borderRadius: '0.25rem',
};
const codeStyle = {
    fontFamily: 'Consolas, Menlo, monospace',
};
function CodeBlock(props) {
    const codeBlock = { __html: props.codeHTML };
    return (React.createElement("pre", { style: preStyle },
        React.createElement("code", { style: codeStyle, dangerouslySetInnerHTML: codeBlock })));
}
export default CodeBlock;
